<script setup lang="ts">
import {Program} from "@/program/interfaces/Program";
import useNotificationSequenceIndex from "@/notification-sequences/composables/useNotificationSequenceIndex";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import {NotificationSequenceCard} from "@/notification-sequences/components/notification-sequence-card";
import {useRouter} from "vue-router";

const router = useRouter();
const props = defineProps<{
    program: Program
}>();

const {data, isLoading} = useNotificationSequenceIndex({program_id: props.program.id});
</script>

<template>
  <div class="container mx-auto p-4">
    <div>
      <BaseFlexSpinner v-if="isLoading" />
      <div v-else-if="data" class="space-y-4">
        <NotificationSequenceCard
          v-for="sequence in data"
          :key="sequence.id"
          :color="'primary'"
          :sequence="sequence"
          @navigate="_sequence => router.push({
            name: 'program.detail.notification-sequences.show',
            params: {programId: program.id, sequenceId: _sequence.id}
          })"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
